import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=56c4d1e0&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=56c4d1e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4d1e0",
  null
  
)

export default component.exports